export const testimonials = [
  {
    name: "Sarah & James",
    location: "New York, USA",
    rating: 5,
    text: "Tripsyfy made our honeymoon absolutely magical. The Maldives retreat was beyond our wildest dreams — every single detail was perfect. We felt like royalty.",
    trip: "Maldives Luxury Retreat",
    initials: "SJ",
  },
  {
    name: "Michael Robinson",
    location: "Chicago, IL",
    rating: 5,
    text: "The best cruise experience we've ever had. The Mediterranean itinerary was flawlessly planned. Every port stop felt handpicked just for us. We're already planning our next trip.",
    trip: "Mediterranean Cruise",
    initials: "MR",
  },
  {
    name: "Priya Kapoor",
    location: "Houston, TX",
    rating: 5,
    text: "Incredible Swiss Alps tour! The scenery was breathtaking and our guide was phenomenal. Tripsyfy handled everything seamlessly from start to finish.",
    trip: "Swiss Alpine Adventure",
    initials: "PK",
  },
];

export const extendedTestimonials = [
  ...testimonials,
  {
    name: "David & Amara Osei",
    location: "Atlanta, GA",
    rating: 5,
    text: "We needed flights for our whole family to Ghana for a wedding — 14 people, different departure cities. Tripsyfy coordinated everything perfectly. Saved us hours of stress.",
    trip: "Group Family Flights to Ghana",
    initials: "DA",
  },
  {
    name: "Rajan Patel",
    location: "Edison, NJ",
    rating: 5,
    text: "I needed to book last-minute flights to India for a family emergency. Tripsyfy found me a reasonable fare on short notice and walked me through everything in under an hour. Incredibly responsive team.",
    trip: "Emergency Flights to India",
    initials: "RP",
  },
  {
    name: "Linda Torres",
    location: "Dallas, TX",
    rating: 5,
    text: "Our Antarctica expedition exceeded every expectation. The Quark Expeditions ship was phenomenal, and Tripsyfy handled all the logistics — flights, transfers, everything. Not a single hiccup.",
    trip: "Antarctica Polar Expedition",
    initials: "LT",
  },
];
